<script lang="ts">
  import { onMount } from 'svelte';
  import type { Operator } from "@/src/types/components/operators/Operator";
  import ToplistRow from "$lib/admin/components/blocks/helpers/ToplistRow.svelte";
  import Translate from "$lib/admin/components/blocks/helpers/Translate.svelte";
  import dbHttp from "$lib/services/dbHttp";
  import { fetchOperators } from "$lib/data/queries/operators";

  export let props: { toplistId?: string } = { toplistId: undefined };
  export let adminView = false;
  export let toplistOperators: Operator[] = [];

  const toplistProps = {
    toplistFocus: "tournament-sponsor",
    toplistPaymentMethodProvider: "",
    dataElement: "",
  };

  onMount(async () => {
    if (props.toplistId && !toplistOperators?.length && !adminView) {
      await loadToplistOperators(props.toplistId);
    }
  });

  async function loadToplistOperators(toplistId: string): Promise<void> {
    try {
      const { data: toplist, error: toplistError } = await dbHttp.getById("commercials", toplistId);
      if (toplistError) throw toplistError;
      if (!toplist?.[0]?.toplist) throw new Error("Invalid toplist format");

      const { operators, error: operatorError } = await fetchOperators({
        operatorIds: toplist[0].toplist
      });
      if (operatorError) throw operatorError;

      toplistOperators = operators?.filter((operator): operator is Operator => operator !== null) || [];
    } catch (err) {
      console.error("Failed to load toplist operators:", err);
      toplistOperators = [];
    }
  }
</script>

{#if toplistOperators.length}
  <div class="container" style="margin-top: 20px;">
    <h4><Translate text="Best casinos to play" /></h4>
    <div class={`toplist ${toplistProps.toplistFocus} tournament-toplist`} class:show-full={true}>
      {#each toplistOperators as operator, index}
        <ToplistRow
            props={toplistProps}
            {operator}
            toplistPosition={index + 1}
            dataElement="tournament_list"
        />
      {/each}
    </div>
  </div>
{/if}

<style>
    :global(.tournament-sponsor) {
        display: grid;
        grid-template-columns: 1fr;
        gap: 20px;
        margin-bottom: 20px;
    }

    @media only screen and (min-width: 992px) {
        :global(.toplist.tournament-sponsor.tournament-toplist) {
            grid-template-columns: 1fr 1fr 1fr;
        }
    }
</style>
